import { render, staticRenderFns } from "./Baidu.vue?vue&type=template&id=2b7980b4&scoped=true&"
import script from "./Baidu.vue?vue&type=script&lang=js&"
export * from "./Baidu.vue?vue&type=script&lang=js&"
import style0 from "./Baidu.vue?vue&type=style&index=0&id=2b7980b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7980b4",
  null
  
)

export default component.exports